// export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";

// export const KEY_MAINDESTINATION = "maindestination";

export const MAINDESTINATION = "maindestination";
export const FINALDESTINATION = "finaldestination";
export const NEIGHBOURDESTINATION = "neighbourdestination";
export const NEIGHBOUR = "neighbour";
